import { Facebook, Linkedin, Twitter, MessageCircle } from 'lucide-react';

// Partage d'un article sur les réseaux sociaux.
//
// L'URL partagée est toujours celle fournie par l'appelant (siteUrl, calculé
// côté serveur à partir du domaine PRINCIPAL de l'agence — voir
// server/tenant.ts:tenantUrl et server/routes/api.ts) : jamais celle de
// l'onglet du visiteur, qui peut être une variante ("www.", sous-domaine
// feed-it.fr de secours) différente du domaine que l'agence veut voir
// circuler sur les réseaux.
//
// De simples liens d'intention de partage (ouverts dans un nouvel onglet),
// pas d'API : aucune clé, aucun compte à connecter, fonctionne pour toutes
// les agences dès la publication d'un article.

interface SocialShareButtonsProps {
  url: string;
  title: string;
}

export function SocialShareButtons({ url, title }: SocialShareButtonsProps) {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const links = [
    {
      key: 'facebook',
      label: 'Facebook',
      icon: Facebook,
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    },
    {
      key: 'linkedin',
      label: 'LinkedIn',
      icon: Linkedin,
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    },
    {
      key: 'x',
      label: 'X',
      icon: Twitter,
      href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
    },
    {
      key: 'whatsapp',
      label: 'WhatsApp',
      icon: MessageCircle,
      href: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
    },
  ] as const;

  return (
    <div className="flex items-center gap-2">
      <span className="text-[11px] font-bold text-gray-400 uppercase tracking-wide mr-1">Partager :</span>
      {links.map(({ key, label, icon: Icon, href }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Partager sur ${label}`}
          title={`Partager sur ${label}`}
          className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-600 transition-colors"
        >
          <Icon className="w-4 h-4" />
        </a>
      ))}
    </div>
  );
}
